import 'normalize.css/normalize.css';

import App from '../App';
import { constantRouterMap, routeStore } from '../router';
import store from '../store';
import createBaseFetch from './Api';
import configRoutePermission from './permission';
import extendCom from '@/utils/extends';

import '@/assets/styles/index.scss'; // global css

import storeModule from './storeModule';
import mixinModule from './mixins';
import utilsModule from './utils';

const fetch = createBaseFetch({
  baseURL: '',
  timeout: 1000000,
});

class SystemShell {
  constructor() {
    this.Api = fetch;
    this.storeModule = storeModule;
    this.mixinModule = mixinModule;
    this.utils = utilsModule;
    this.createBaseFetch = createBaseFetch;
  }
  createSystem = ({
    basePath = '/',
    routers,
    routeFilter,
    constantRouter,
    whiteList,
  }) => {
    const router = new VueRouter({
      mode: 'history',
      base: basePath,
      scrollBehavior: () => ({ y: 0 }),
      routes:
        constantRouter && constantRouter instanceof Array
          ? [...constantRouterMap, ...constantRouter]
          : constantRouterMap,
    });
    routeStore.install(store);
    extendCom(Vue);
    const allWhiteList =
      whiteList && typeof whiteList === 'string'
        ? [
            ...process.env.VUE_APP_WHITE_LIST.split(','),
            ...whiteList.split(','),
          ]
        : process.env.VUE_APP_WHITE_LIST.split(','); // 不重定向白名单

    store.dispatch('getWhiteList', allWhiteList);
    configRoutePermission(router, store, routers, allWhiteList);
    Vue.config.productionTip = false;

    let app = new Vue({
      el: '#app',
      router,
      store,
      render: h => {
        let routes = [...constantRouterMap];
        let allRoute = store.getters.asyncRoutes;
        if (typeof routeFilter === 'function') {
          const data = routeFilter(routes, allRoute);
          routes = data.routes;
          allRoute = data.allRoute;
        }
        return <App route={routes} allRoutes={allRoute} />;
      },
    });
    return app;
  };
}
export default new SystemShell();
